import { render, staticRenderFns } from "./totalscoretemplate.vue?vue&type=template&id=1767ded1&scoped=true"
import script from "./totalscoretemplate.vue?vue&type=script&lang=js"
export * from "./totalscoretemplate.vue?vue&type=script&lang=js"
import style0 from "./totalscoretemplate.vue?vue&type=style&index=0&id=1767ded1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1767ded1",
  null
  
)

export default component.exports